import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { priorityOptions } from '../../../../utils/OptionUtils';
import SelectTag from '../../../../components/SelectTag';

const CreateSubscriptionTicketModal = ({ show, handleClose, handleSubmit, control, onTicketSubmit, errors, planData, customerOptions = [], setCustomerId = {} }) => {
  return (
    <Modal show={show} onHide={handleClose} className='modal-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Create Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onTicketSubmit)}>
          {customerOptions.length > 0 && (
            <div className="mb-3">
              <label className="form-label fw-bold">Customer</label>
              <SelectTag
                name="customer_id"
                control={control}
                options={customerOptions}
                label="customer"
                onChange={(selectedCustomer) => {
                  setCustomerId(selectedCustomer?.value);
                }}
              />
              {errors?.customer_id && <small className="text-danger">{errors?.customer_id?.message}</small>}
            </div>
          )}
          {planData?.checklists?.length > 0 ? (
            <div key={planData.id} className="mb-4">
              <h3 className="text-primary mb-3 text-center">{planData.name}</h3>
              <div className="mb-3">
                <div className="ps-3 row">
                  {planData.checklists?.map((checklist) => (
                    <div className="col-6 col-md-6" key={checklist.id} >
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id={`checklist-${checklist.id}`}
                          value={checklist.id}
                          {...control.register('checklist_id', { required: true })}
                        />
                        <label
                          htmlFor={`checklist-${checklist.id}`}
                          className="form-check-label"
                        >
                          {checklist.name}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                {errors.checklist_id && (
                  <p className="text-danger mt-3">Please select a checklist to proceed.</p>
                )}

              </div>
            </div>
          ) : (
            <div className="text-center text-muted mb-4">
              <p className='text-danger'>Please purchase a plan to create a ticket.</p>
            </div>
          )}
          <div className="mb-3">
            <div className="col">
              <label className="fw-bold">Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                {...control.register('title', {
                  required: 'Title is required.',
                  maxLength: {
                    value: 60,
                    message: 'Title must not exceed 60 characters.',
                  },
                })}
              />
              {errors.title && (
                <p className="text-danger mt-2">{errors.title.message}</p>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <label className="fw-bold">Description</label>
              <textarea
                className="form-control"
                placeholder="Enter description"
                {...control.register('description', { required: true, maxLength: 255 })}
              />
              {errors.description && (
                <p className="text-danger mt-2">Description is required.</p>
              )}
            </div>
          </div>

          <div className="row mt-3">
            <div className="col">
              <label className="fw-bold">Priority</label>
              <Controller
                name="priority"
                control={control}
                render={({ field }) => (
                  <select
                    {...field}
                    className="form-select"
                    value={field.value || ''}
                    onChange={(e) => field.onChange(e.target.value)}
                  >
                    <option value="" disabled>
                      Select a priority
                    </option>
                    {priorityOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors.priority && (
                <p className="text-danger mt-2">Priority is required.</p>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <Button variant="danger" size='sm' onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" size='sm' variant="primary">
              Create
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateSubscriptionTicketModal;
